import { Fragment } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { animated, useTransition } from "react-spring";
import IntroMobile from "Views/IntroMobile";
import NotFoud from "Views/NotFoud";
import Start from "Views/Start";

export const RouterMobile = ({
  setPageTitle,
  setShowMenuToggler,
  setIsBackgroundMusic,
  setReturnLink,
}) => {
  const location = useLocation();

  const transitions = useTransition(location, {
    key: location,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    config: { duration: 1000 },
    exitBeforeEnter: true,
  });
  return (
    <Fragment>
      {transitions((props, item) => {
        return (
          <animated.div style={{ ...props }}>
            <Routes location={location}>
              <Route
                path="/"
                element={
                  <Start
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route
                path="/intro"
                element={
                  <IntroMobile
                    setPageTitle={setPageTitle}
                    setShowMenuToggler={setShowMenuToggler}
                    setIsBackgroundMusic={setIsBackgroundMusic}
                    setReturnLink={setReturnLink}
                  />
                }
              />
              <Route path="*" element={<NotFoud />} />
            </Routes>
          </animated.div>
        );
      })}
    </Fragment>
  );
};
